// ./app/shared/if.directive.ts
import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { DacConfig } from "../services/dac-config.service";

@Directive({ selector: '[ifFeatureEnabled]' })
export class IfFeatureEnabled {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private dacConfig: DacConfig
    ) { }

  @Input() set ifFeatureEnabled(feature: string) {
    if (this.dacConfig.isFeatureEnabled(feature)) {
      // If condition is true add template to DOM
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
     // Else remove template from DOM
      this.viewContainer.clear();
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/shared/feature-enabled/feature-enabled.ts